import { css } from "@emotion/css";
import React from "react";

import { IndeterminateIcon } from "./assets/IndeterminateIcon";
import { Icon } from "../../../foundations/icons/Icon/Icon";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  isSelected?: boolean;
  isIndeterminate?: boolean;
  isDisabled?: boolean;
  isFocusVisible?: boolean;
  isHovered?: boolean;
}

export function CheckboxControl(props: Props) {
  const { isSelected, isIndeterminate, isDisabled, isFocusVisible, isHovered } =
    props;

  const selected = isSelected && !isIndeterminate;
  const filled = selected || isIndeterminate;

  return (
    <div className={styles.container}>
      <div
        className={css(
          styles.checkbox,
          {
            borderColor: "var(--background-selected-medium)",
          },
          !filled &&
            !isDisabled && {
              "&:hover": {
                borderColor: "var(--border-input-hover)",
              },
            },
          isHovered &&
            !filled &&
            !isDisabled && {
              "&:hover": {
                borderColor: "var(--border-input-hover)",
              },
              borderColor: "var(--border-input-hover)",
            },
          filled && {
            borderWidth: 0,
            backgroundColor: "var(--background-selected-strong)",
          },
          isDisabled && {
            cursor: "not-allowed",
            borderColor: "var(--background-selected-disabled)",
          },
          isDisabled &&
            filled && {
              backgroundColor: "var(--background-selected-disabled)",
            },
          isFocusVisible && {
            boxShadow: "var(--focus-action)",
          }
        )}
      >
        {selected && (
          <Icon
            name="check"
            color="icon-inverse"
            type="mini"
            testID="checked-icon-wrapper"
          />
        )}
        {isIndeterminate && <IndeterminateIcon />}
      </div>
    </div>
  );
}

const styles = {
  container: css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    height: 20,
    justifyContent: "center",
    width: 20,
  }),
  checkbox: css({
    alignItems: "center",
    borderRadius: "var(--border-radius-2)",
    borderStyle: "solid",
    borderWidth: 2,
    boxSizing: "border-box",
    display: "flex",
    height: 18,
    justifyContent: "center",
    width: 18,
  }),
};
